export const formFields = [
  {
    label: 'Steps',
    htmlFor: 'steps',
    name: 'steps',
    type: 'number',
    inputProps: { maxLength: 1, min: 1 },
  },
  {
    label: 'Guidance scale',
    htmlFor: 'guidanceScale',
    name: 'guidanceScale',
    type: 'number',
  },
  {
    label: 'Frames:',
    htmlFor: 'frames',
    name: 'frames',
    type: 'number',
  },
  {
    label: 'Width:',
    htmlFor: 'width',
    name: 'width',
    type: 'number',
  },
  {
    label: 'Height:',
    htmlFor: 'height',
    name: 'height',
    type: 'number',
  },
  {
    label: 'Zoom In Motion Strength:',
    htmlFor: 'zoomInMotionStrength',
    name: 'zoomInMotionStrength',
    type: 'number',
  },
  {
    label: 'Zoom Out Motion Strength:',
    htmlFor: 'zoomOutMotionStrength',
    name: 'zoomOutMotionStrength',
    type: 'number',
  },
  {
    label: 'Pen Right Motion Strength:',
    htmlFor: 'penRightMotionStrength',
    name: 'penRightMotionStrength',
    type: 'number',
  },
  {
    label: 'Pen Left Motion Strength:',
    htmlFor: 'penLeftMotionStrength',
    name: 'penLeftMotionStrength',
    type: 'number',
  },
  {
    label: 'Pan Up Motion Strength:',
    htmlFor: 'panUpMotionStrength',
    name: 'panUpMotionStrength',
    type: 'number',
  },
  {
    label: 'Pan Down Motion Strength:',
    htmlFor: 'panDownMotionStrength',
    name: 'panDownMotionStrength',
    type: 'number',
  },
  {
    label: 'Rolling Clockwise Motion Strength',
    htmlFor: 'rollingClockwiseMotionStrength',
    name: 'rollingClockwiseMotionStrength',
    type: 'number',
  },
  {
    label: 'Rolling Counter clockwise Motion Strength',
    htmlFor: 'rollingCounterclockwiseMotionStrength',
    name: 'rollingCounterclockwiseMotionStrength',
    type: 'number',
  },
];

export interface FormData {
  prompt: string;
  negativePrompt: string;
  baseModel: string;
  steps: number;
  guidanceScale: number;
  frames: number;
  width: number;
  height: number;
  seed: number;
  zoomInMotionStrength: number;
  zoomOutMotionStrength: number;
  penRightMotionStrength: number;
  penLeftMotionStrength: number;
  panUpMotionStrength: number;
  panDownMotionStrength: number;
  rollingClockwiseMotionStrength: number;
  rollingCounterclockwiseMotionStrength: number;
  text: string;
}

export const baseModels = [
  'realisticVisionV20_v20',
  'lyriel_v16',
  'majicmixRealistic_v5Preview',
  'rcnzCartoon3d_v10',
  'toonyou_beta3',
];

export const defaultFormData: FormData = {
  prompt: '',
  negativePrompt: '',
  baseModel: 'realisticVisionV20_v20',
  steps: 50,
  guidanceScale: 7.5,
  frames: 30,
  width: 512,
  height: 512,
  seed: 0,
  zoomInMotionStrength: 0.1,
  zoomOutMotionStrength: 0.1,
  penRightMotionStrength: 0.1,
  penLeftMotionStrength: 0.1,
  panUpMotionStrength: 0.1,
  panDownMotionStrength: 0.1,
  rollingClockwiseMotionStrength: 0.1,
  rollingCounterclockwiseMotionStrength: 0.1,
  text: '',
};
